<template>
  <div class="order-item">
    <div class="item-image">
      <img 
        :src="`https://api.ultimatum.store/image/${d.productid.images[0]}?quality=100&width=160&format=${getImageFormat(d.productid.images[0])}`" 
        :alt="d.name"
      >
    </div>

    <div class="item-info">
      <div class="item-name">{{ d.name }}</div>
      <div class="item-sku" v-if="d.productid.artikul">Артикул: {{ d.productid.artikul }}</div>
    </div>

    <div class="item-quantity">
      <span class="quantity-badge">{{ d.quantity }} шт</span>
    </div>
  </div>
</template>

<script setup>
import { getImageFormat } from '@/controlles/general'
const { d } = defineProps(['d'])
</script>

<style scoped>
.order-item {
  display: grid;
  grid-template-columns: 60px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  border-radius: var(--border-radius-md);
  box-shadow: 0 2px 4px var(--shadow-color);
  transition: all var(--transition-fast);
  margin-bottom: 8px;
}

.order-item:hover {
  background: var(--tile-hover-bg);
  border-color: var(--tile-hover-border);
}

/* Фото товара */
.item-image {
  width: 60px;
  height: 60px;
  border-radius: var(--border-radius-sm);
  overflow: hidden;
  background: var(--tile-icon-bg);
  flex-shrink: 0;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}


.item-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0; 
}

.item-name {
      font-size: 13px;
    font-weight: 500;
    color: var(--text-primary);
    line-height: 1.3;
    word-break: break-word;
    text-align: left;
}

.item-sku {
  font-size: 11px;
  color: var(--text-tertiary);
  font-weight: 300;
   text-align: left;
}

/* Количество товара */
.item-quantity {
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-badge {
  display: inline-block;
  padding: 4px 10px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius-xl);
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  white-space: nowrap;
}

/* Темная тема */
html.dark .quantity-badge {
  background: var(--bg-secondary);
  border-color: var(--border-medium);
}

</style>